import { ArrowDown, ArrowUp, Copy, Pencil, RefreshCw, Trash2 } from 'lucide-react'
import type { Product } from '../types'

export function ProductActions({ product, onEdit, onReplace, onDuplicate, onDelete, onMoveUp, onMoveDown }: { product: Product; onEdit: () => void; onReplace: () => void; onDuplicate: () => void; onDelete: () => void; onMoveUp:()=>void; onMoveDown:()=>void }) {
  return <div className="card-actions" onClick={(event) => event.stopPropagation()}>
    <button onClick={onReplace}><RefreshCw size={13}/>替换</button>
    <button onClick={onEdit}><Pencil size={13}/>编辑</button>
    <button onClick={onDuplicate}><Copy size={13}/>复制</button>
    <button aria-label="向上排序" onClick={onMoveUp}><ArrowUp size={13}/></button><button aria-label="向下排序" onClick={onMoveDown}><ArrowDown size={13}/></button>
    <button className="danger" onClick={() => { if (confirm(`确定删除“${product.title}”吗？`)) onDelete() }}><Trash2 size={13}/>删除</button>
  </div>
}
